/**
 * Generate a unique default collection name by appending an incrementing
 * suffix when the base name already exists.
 *
 * Pattern: "New Collection", "New Collection 2", "New Collection 3", ...
 */
export function generateDefaultCollectionName(
  existingNames: string[],
  baseName: string
): string {
  const lowerNames = new Set(existingNames.map((n) => n.toLowerCase().trim()));

  if (!lowerNames.has(baseName.toLowerCase())) {
    return baseName;
  }

  let counter = 2;
  while (lowerNames.has(`${baseName.toLowerCase()} ${counter}`)) {
    counter++;
  }
  return `${baseName} ${counter}`;
}
